/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterMaterial_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectSearch_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterMaterial_itemSearch";
};
export type SbSharedRefineMenuFilterMaterial_itemSearch$data = SbSharedRefineMenuFilterMaterial_itemSearch;
export type SbSharedRefineMenuFilterMaterial_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterMaterial_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterMaterial_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterMaterial_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'e4320fb9621490e9f4b178f431f71274';
export default node;
